// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAppDownloadArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.137 1.633c.338.338.528.796.53 1.274v18.384a1.807 1.807 0 0 1-1.804 1.807h-9.775a1.81 1.81 0 0 1-1.807-1.807v-2.4c.254-.078.502-.172.744-.28v2.687a1.062 1.062 0 0 0 1.063 1.063h9.792a1.063 1.063 0 0 0 1.063-1.063V2.908a1.064 1.064 0 0 0-1.08-1.046h-9.775a1.063 1.063 0 0 0-1.063 1.06v4.456a6.659 6.659 0 0 0-.744-.28v-4.19a1.807 1.807 0 0 1 1.807-1.804h9.775c.478 0 .936.191 1.274.53z"
    />
    <path
      fill="currentColor"
      d="M11.491 18.46a.37.37 0 0 1-.108-.261v-.425a6.67 6.67 0 0 0 .74-.72v.775h7.704V4.457h-7.704V8.95a6.678 6.678 0 0 0-.74-.72V4.087a.37.37 0 0 1 .37-.37h8.448a.37.37 0 0 1 .37.37v14.112a.37.37 0 0 1-.373.37h-8.445a.37.37 0 0 1-.262-.108zM16.701 19.806a1.029 1.029 0 1 1-1.454 1.455 1.029 1.029 0 0 1 1.454-1.455z"
    />
    <path
      fill="currentColor"
      d="M10.011 18.624a6.173 6.173 0 0 1-8.735-5.616 6.172 6.172 0 0 1 8.735-5.616c.491.219.952.5 1.372.837.264.216.512.452.74.706a6.134 6.134 0 0 1 0 8.119 6.68 6.68 0 0 1-.74.72 6.26 6.26 0 0 1-1.372.85zm-6.347-9.46a5.427 5.427 0 0 0-1.59 3.83 5.42 5.42 0 1 0 5.42-5.42 5.427 5.427 0 0 0-3.83 1.59z"
    />
    <path
      fill="currentColor"
      d="m7.487 15.747-.342-.342V9.878a.351.351 0 0 1 .702 0v5.527z"
    />
    <path
      fill="currentColor"
      d="M3.976 13.234a.358.358 0 0 1 .515-.497l2.67 2.668.343.342.343-.342 2.671-2.668a.351.351 0 0 1 .497.497l-3.27 3.268a.342.342 0 0 1-.498 0z"
    />
  </svg>
);
export default SvgAppDownloadArrow;
